import { createContext, useState, useEffect, useContext } from 'react';
import { AccountContext } from './account-context'
import { ErrorContext } from './error-context'
import { getTasksAll } from '../common/api-requests';
import { SocketContext } from './socket-context';

const TasksContext = createContext(null);

const TasksProvider = ({ children }) => {

    const [account, setAccount] = useContext(AccountContext);
    const [stateAccount, setStateAccount] = useState(account);

    const [error, setError] = useContext(ErrorContext);
    const [tasks, setTasks] = useState([]);
    const [socket, setSocket] = useContext(SocketContext);

    useEffect(() => {
        setStateAccount(account);
    }, [account]);

    useEffect(() => {

        if (!stateAccount)
            return;

        getTasksAll().then((response) => {
            setTasks(response);
        })
            .catch((errorInner) => {
                setError("(" + errorInner.status + ")" + " " + errorInner.text);
            });

    }, [stateAccount]);

    useEffect(() => {
        if (!socket || socket.type != 1)
            return;

        const taskIndex = tasks.findIndex(obj => obj.id === socket.id);

        if (socket.isComplete) {
            if (taskIndex !== -1){
                const updTasks = tasks.filter(item => item.id !== socket.id);
                setTasks([...updTasks]);
            }
        }
        else {

            if (socket.action == 1 && taskIndex === -1 && socket.isTask && socket.recipientAccountID === account.id){
                setTasks([...tasks, socket]);
            }
            else if (socket.action == 2 && taskIndex !== -1){
                
                if (socket.recipientAccountID !== account.id){
                    const updTasks = tasks.filter(item => item.id !== socket.id);
                    setTasks([...updTasks]); 
                }
                else{
                    const tasksUpd = [...tasks];
                    tasksUpd[taskIndex] = socket;
                    setTasks([...tasksUpd]);
                }
            }
            else if (socket.action == 3 && taskIndex !== -1){
                
                setTasks(prevTasks => {
                    const updTasks = prevTasks.filter(item => item.id !== socket.id);
                    return updTasks;
                });
            }
        }
    }, [socket]);


    return (
        <TasksContext.Provider value={[tasks, setTasks]}>
            {children}
        </TasksContext.Provider>
    )
}

export { TasksContext, TasksProvider };

